function ProjectCard({ project, token, refresh }) {
  const approveProject = () => {
    fetch(
      `http://localhost:8080/api/projects/${project._id}/approve`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then(() => refresh());
  };

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "16px",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      <h3 style={{ marginBottom: "8px" }}>
        Project ID: {project._id}
      </h3>

      <p>
        <strong>Status:</strong>{" "}
        <span
          style={{
            color: project.approved ? "green" : "orange",
            fontWeight: "bold",
          }}
        >
          {project.status}
        </span>
      </p>

      <p>
        <strong>Approved:</strong>{" "}
        {project.approved ? "Yes" : "No"}
      </p>

      {!project.approved && (
        <button
          onClick={approveProject}
          style={{
            marginTop: "10px",
            padding: "8px 14px",
            background: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          Approve Project
        </button>
      )}
    </div>
  );
}

export default ProjectCard;
